/* Le Lamier — dá vida ao markup fiel da PDP.
   O espelho traz os formulários e os custom elements do tema da referência
   (<product-form>, <variant-picker>, <media-gallery>) mas não o JS deles.
   Aqui ligamos o essencial: trocar de variante, trocar a imagem principal e
   adicionar ao carrinho abrindo o drawer. */
(function () {
  'use strict';

  function raizes() {
    return [].slice.call(document.querySelectorAll('[id^="shopify-section"]'))
      .filter(function (s) { return s.querySelector('form.shopify-product-form'); });
  }

  /* ---------- variantes ---------- */
  function formDe(el) {
    var id = el.getAttribute('form');
    return (id && document.getElementById(id)) || el.closest('form');
  }

  function aplicaVariante(entrada) {
    var form = formDe(entrada);
    if (!form) return;
    var vid = entrada.getAttribute('data-variant-id') ||
              entrada.getAttribute('data-value-id') ||
              entrada.value;
    // o rótulo visível da cor escolhida
    var rot = entrada.getAttribute('data-option-value') ||
              (entrada.nextElementSibling && entrada.nextElementSibling.textContent) || '';
    var saida = form.closest('[id^="shopify-section"]');
    if (saida && rot.trim()) {
      var alvo = saida.querySelector('[class*="selected-value"],[class*="option__value"],[data-selected-value]');
      if (alvo) alvo.textContent = rot.trim();
    }
    if (vid && /^\d{8,}$/.test(String(vid))) {
      fixaVariante(form.closest('[id^="shopify-section"]') || document, vid);
    }
    var img = entrada.getAttribute('data-variant-image');
    if (img && saida) trocaImagem(saida, img);
  }

  /* ---------- galeria ---------- */
  function trocaImagem(raiz, src) {
    var principal = raiz.querySelector('[class*="product-gallery"] img, [class*="media-gallery"] img, .product__media img');
    if (principal) { principal.src = src; principal.removeAttribute('srcset'); }
  }

  /* Os swatches do app Globo não usam name="option1": o id da variante fica no
     <li data-variantid> e o rótulo no data-value. */
  /* O formulário visível chega com <input name="id"> DESABILITADO e com o id da
     variante da referência — no tema original é o <variant-picker> que o
     habilita e preenche. Sem isto o POST vai sem `id` e a Shopify responde
     "Parameter Missing or Invalid". Cuidado: form.id devolve esse input, não a
     string; use getAttribute('id'). */
  function fixaVariante(raiz, vid) {
    if (!vid) return;
    var forms = raiz.querySelectorAll('form.shopify-product-form');
    for (var i = 0; i < forms.length; i++) {
      var campos = forms[i].querySelectorAll('input[name="id"]');
      for (var j = 0; j < campos.length; j++) {
        campos[j].disabled = false;
        campos[j].removeAttribute('disabled');
        campos[j].value = vid;
      }
    }
  }

  function aplicaGlobo(entrada) {
    var li = entrada.closest('li[data-variantid]');
    if (!li) return;
    var vid = li.getAttribute('data-variantid');
    var rot = li.getAttribute('data-value') || '';
    var raiz = li.closest('[id^="shopify-section"]') || document;
    fixaVariante(raiz, vid);
    // mantém o variant-picker nativo em sincronia (ele é escondido por CSS)
    var nativo = raiz.querySelector('input[type="radio"][name^="option"][value="' + rot + '"]');
    if (nativo) nativo.checked = true;
    var nomeVar = raiz.querySelector('.name-variant');
    if (nomeVar) nomeVar.innerHTML = '<span>: </span>' + rot;
    var img = li.getAttribute('data-variant-image');
    if (img) trocaImagem(raiz, img);
    else fotoDaVariante(raiz, vid);
  }

  /* Foto da variante: o markup do espelho não traz data-variant-image, então
     buscamos a featured_image da variante no .js do produto e levamos a galeria
     (slide principal, miniatura marcada e scroller do mobile) para ela. */
  var _produtoJs = {};
  function produtoJs() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return Promise.resolve(null);
    var h = m[1];
    if (!_produtoJs[h]) _produtoJs[h] = fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).catch(function () { return null; });
    return _produtoJs[h];
  }
  function fotoDaVariante(raiz, vid) {
    produtoJs().then(function (p) {
      if (!p) return;
      var v = (p.variants || []).filter(function (x) { return String(x.id) === String(vid); })[0];
      if (!v || !v.featured_image) return;
      var pos = v.featured_image.position || 1;
      var src = v.featured_image.src;
      src = (src.indexOf('//') === 0 ? 'https:' : '') + src;
      src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=1500';
      // slides: vai para o slide da posição da foto, se existir; senão troca a imagem do primeiro
      var slides = raiz.querySelectorAll('.product__media-item');
      var alvo = slides[pos - 1];
      var lista = raiz.querySelector('.product__media-list');
      if (alvo && lista && lista.scrollWidth > lista.clientWidth + 4) {
        lista.scrollTo({ left: alvo.offsetLeft - lista.offsetLeft, behavior: 'smooth' });
      } else {
        trocaImagem(raiz, src);
      }
      // miniaturas: marca a da foto da variante
      raiz.querySelectorAll('.product__thumbnail-list, [class*="thumbnail-list"]').forEach(function (l) {
        var itens = l.querySelectorAll('.product__thumbnail-item, [class*="thumbnail-item"]');
        itens.forEach(function (it, i) {
          var b = it.querySelector('.product__thumbnail, button, a') || it;
          if (i === pos - 1) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
        });
      });
      agruparMidia(raiz, p, pos);
    });
  }

  /* Galeria agrupada por cor, como na referência: cada variante mostra da sua
     foto destacada até a foto destacada da variante seguinte. */
  function agruparMidia(raiz, p, pos) {
    var inicios = (p.variants || []).map(function (x) { return x.featured_image && x.featured_image.position; })
      .filter(Boolean).filter(function (x, i, a) { return a.indexOf(x) === i; }).sort(function (a, b) { return a - b; });
    if (inicios.length < 2) return;
    var ini = inicios.filter(function (x) { return x <= pos; }).pop() || inicios[0];
    var fim = (inicios.filter(function (x) { return x > ini; })[0] || Infinity) - 1;
    var dentro = function (i) { return i + 1 >= ini && i + 1 <= fim; };
    raiz.querySelectorAll('.product__media-item').forEach(function (s, i) { s.style.display = dentro(i) ? '' : 'none'; });
    raiz.querySelectorAll('.product__thumbnail-list, [class*="thumbnail-list"]').forEach(function (l) {
      l.querySelectorAll('.product__thumbnail-item, [class*="thumbnail-item"]').forEach(function (it, i) { it.style.display = dentro(i) ? '' : 'none'; });
    });
  }

  document.addEventListener('change', function (e) {
    var alvo = e.target;
    if (!alvo || !alvo.matches) return;
    if (alvo.matches('[data-globoswatchindex]')) { aplicaGlobo(alvo); return; }
    if (alvo.matches('input[type="radio"][name^="option"], select[name^="option"]')) aplicaVariante(alvo);
  });
  // o <label> do Globo cobre o input; o clique nele já dispara change, mas em
  // alguns navegadores o input fica atrás do label com font-size 0.
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var lab = e.target.closest('.globo-swatch-list label[for]');
    if (!lab) return;
    var inp = document.getElementById(lab.getAttribute('for'));
    if (inp && !inp.checked) { inp.checked = true; aplicaGlobo(inp); }
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var mini = e.target.closest('[class*="thumbnail"] img, [class*="thumb"] button, [class*="gallery"] [class*="thumb"]');
    if (!mini) return;
    var img = mini.tagName === 'IMG' ? mini : mini.querySelector('img');
    if (!img) return;
    var raiz = mini.closest('[id^="shopify-section"]');
    if (raiz) trocaImagem(raiz, img.getAttribute('data-full') || img.src);
  });

  /* ---------- adicionar ao carrinho ---------- */
  function abreDrawer(res) {
    try {
      var html = res && res.sections && res.sections['cart-drawer-section'];
      var atual = document.getElementById('shopify-section-cart-drawer-section');
      if (html && atual) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var novo = tmp.querySelector('#shopify-section-cart-drawer-section');
        atual.innerHTML = novo ? novo.innerHTML : html;
      }
    } catch (e) {}
    var d = document.querySelector('theme-drawer#cart-drawer') ||
            (document.querySelector('cart-drawer-component') || {}).closest &&
             document.querySelector('cart-drawer-component').closest('theme-drawer');
    try { if (d && typeof d.open === 'function') d.open(); } catch (e) {}
  }

  /* Brinde da promoção "Pack de 100 lames OFFERT".
     O desconto BXGY da Shopify zera o preço do brinde, mas NÃO o coloca no
     carrinho: quem adiciona é o front. A configuração é escrita pelo passo 27,
     lida do próprio desconto ativo, para não haver id fixo no código. */
  function brindeDe(form) {
    var cfg = window.LL_BRINDE;
    if (!cfg || !cfg.variante || !cfg.elegiveis) return null;
    var raiz = form.closest('[id^="shopify-section"]') || document;
    var link = raiz.querySelector('a[href*="/products/"]');
    var handle = (location.pathname.match(/\/products\/([a-z0-9-]+)/) || [])[1];
    if (!handle && link) handle = (link.getAttribute('href').match(/\/products\/([a-z0-9-]+)/) || [])[1];
    if (cfg.elegiveis.indexOf(handle) < 0) return null;
    return Number(cfg.variante);
  }

  function itensDoForm(form) {
    var itens = [];
    var principal = form.querySelector('input[name="id"]:not([disabled])') ||
                    form.querySelector('input[name="id"]');
    if (principal && principal.value) itens.push({ id: Number(principal.value), quantity: 1 });
    var brinde = brindeDe(form);
    if (brinde && !itens.some(function (i) { return i.id === brinde; })) {
      itens.push({ id: brinde, quantity: 1 });
    }
    // brindes e upsells marcados dentro do mesmo bloco
    var raiz = form.closest('[id^="shopify-section"]') || document;
    [].slice.call(raiz.querySelectorAll('input[type="checkbox"][data-variant-id]')).forEach(function (cb) {
      if (!cb.checked) return;
      itens.push({ id: Number(cb.getAttribute('data-variant-id')), quantity: 1 });
    });
    return itens.filter(function (i) { return i.id; });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form.shopify-product-form')) return;
    var itens = itensDoForm(form);
    if (!itens.length) return;                 // deixa o Shopify tratar
    e.preventDefault();
    var botao = form.querySelector('[type="submit"]');
    if (botao && botao.getAttribute('data-ocupado')) return;
    var rotulo = botao ? botao.textContent : '';
    if (botao) { botao.setAttribute('data-ocupado', '1'); botao.textContent = 'AJOUT EN COURS…'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: itens, sections: ['cart-drawer-section'], sections_url: '/' }),
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        abreDrawer(res);
        if (botao) { botao.textContent = rotulo; botao.removeAttribute('data-ocupado'); }
      })
      .catch(function () { location.href = '/cart'; });
  }, true);

  // botão de compra fora de formulário (Le Lamier d'Or): adiciona a variante do data-ll-add;
  // o mini carrinho intercepta o /cart/add.js e abre a gaveta
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ll-add]');
    if (!b) return;
    e.preventDefault();
    if (b.getAttribute('data-ocupado')) return;
    var rotulo = b.textContent;
    b.setAttribute('data-ocupado', '1'); b.textContent = 'AJOUT EN COURS…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-ll-add')), quantity: 1 }] }),
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); })
      .catch(function () { location.href = '/cart'; })
      .then(function () { b.textContent = rotulo; b.removeAttribute('data-ocupado'); });
  });

  // botões que não estão dentro de <form> (quick buy do espelho)
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var b = e.target.closest('button[type="submit"][form]');
    if (!b) return;
    var form = document.getElementById(b.getAttribute('form'));
    if (!form || !form.matches('form.shopify-product-form')) return;
    e.preventDefault();
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  });

  /* ---------- vídeos ----------
     O espelho traz <video class="lazy" data-src="..."> sem src: quem hidrata é
     o JS do app, que não vem junto. Carregamos quando entram na tela. */
  function hidrataVideo(v) {
    if (v.__llPronto) return;
    var src = v.getAttribute('data-src');
    if (!src) return;
    v.__llPronto = true;
    v.src = src;
    v.muted = true;
    v.setAttribute('playsinline', '');
    v.load();
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function ligaVideos() {
    var vs = [].slice.call(document.querySelectorAll('video[data-src]'));
    if (!vs.length) return;
    if (!('IntersectionObserver' in window)) { vs.forEach(hidrataVideo); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) { if (e.target.__llPronto) e.target.pause(); return; }
        hidrataVideo(e.target);
        var p = e.target.play();
        if (p && p.catch) p.catch(function () {});
      });
    }, { threshold: 0.25 });
    vs.forEach(function (v) { io.observe(v); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ligaVideos);
  else ligaVideos();
  window.addEventListener('load', ligaVideos);

  // clique no vídeo: alterna som, como um player de social
  document.addEventListener('click', function (e) {
    var v = e.target && e.target.closest && e.target.closest('video[data-src]');
    if (!v) return;
    v.muted = !v.muted;
    if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  });

  /* Estado inicial: habilita e preenche o input de variante. A fonte da verdade
     é o swatch marcado; se não houver swatches (produto de variante única),
     usamos o rádio nativo ou o primeiro <input name="id"> com valor plausível. */
  function iniciar() {
    raizes().forEach(function (raiz) {
      var sw = raiz.querySelector('.globo-swatch-list input[data-globoswatchindex]:checked') ||
               raiz.querySelector('.globo-swatch-list input[data-globoswatchindex]');
      if (sw) { aplicaGlobo(sw); return; }
      var m = raiz.querySelector('input[type="radio"][name^="option"]:checked');
      if (m) { aplicaVariante(m); return; }
      // variante única: o id correto já foi remapeado no markup do formulário
      var campos = raiz.querySelectorAll('form.shopify-product-form input[name="id"]');
      for (var i = 0; i < campos.length; i++) {
        if (!campos[i].disabled && campos[i].value) { fixaVariante(raiz, campos[i].value); return; }
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  window.addEventListener('load', iniciar);
})();
